import React from "react";
import { useNavigate } from "react-router-dom";

const posts = [
  {
    id: 1,
    title: "Stroke membuat saya tidak berguna",
    author: "Risya Kumala",
    time: "5 menit yang lalu",
    content:
      "Halo teman2! Saya merupakan pasien stroke sejak 6 bln yang lalu. Saya ibu rumah tangga. Biasa sehari2 bisa masak untuk suami dan anak2. Tapi sekarang susah sekali. Paling hanya bisa goreng2 sedikit...",
    comments: 3,
    likes: 7,
  },
  {
    id: 2,
    title: "Lelah, letih, merawat si bapak",
    author: "Anonim",
    time: "17 menit yang lalu",
    content:
      "Selamat malam. Saya seorang mantan pegawai negeri. Suami saya kena stroke satu tahun lalu. Semenjak itu, saya berhenti bekerja untuk menjaga suami...",
    comments: 5,
    likes: 11,
  },
  {
    id: 3,
    title: "Gundah gelisah tiap malam",
    author: "Nando Suraja",
    time: "1 jam yang lalu",
    content:
      "Kenapa ya setiap malam saya merasa hati tidak tenang, pengen nangis terus, tapi ngga tau apa yg saya pikirin...",
    comments: 2,
    likes: 3,
  },
  {
    id: 4,
    title: "Cara tepat menghibur diri saat sedih",
    author: "Mursida",
    time: "1 jam yang lalu",
    content:
      "Di pertemanan, saya termasuk orang yg ceria, tapi di rumah saya sering menangis diam2...",
    comments: 4,
    likes: 5,
  },
];

export default function DukunganEmosional() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white px-4 py-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <button onClick={() => navigate(-1)}>
          <img src="/icon-back.png" alt="Back" className="h-6 w-6" />
        </button>
        <h1 className="text-xl font-semibold">Dukungan Emosional</h1>
        <div className="h-6 w-6" /> {/* empty space for balance */}
      </div>

      {/* Posts */}
      <div className="space-y-4 pb-20">
        {posts.map((post) => {
          const isClickable = post.title === "Gundah gelisah tiap malam";
          return (
            <button
              key={post.id}
              onClick={() => {
                if (isClickable) {
                  navigate(`/discussion/${post.id}`);
                }
              }}
              className="w-full text-left border rounded-xl p-4 shadow-sm hover:bg-gray-50 transition"
            >
              <h2 className="font-semibold text-sm mb-1">{post.title}</h2>
              <p className="text-xs text-gray-500 mb-2">
                {post.author} • {post.time}
              </p>
              <p className="text-sm text-gray-700 mb-3 line-clamp-3">
                {post.content}
              </p>
              <div className="flex justify-end gap-6 text-xs text-gray-500">
                <div className="flex items-center gap-1">
                  <img
                    src="/icon-comment.png"
                    alt="Comments"
                    className="h-4 w-4"
                  />
                  <span>{post.comments}</span>
                </div>
                <div className="flex items-center gap-1">
                  <img src="/icon-like.png" alt="Likes" className="h-4 w-4" />
                  <span>{post.likes}</span>
                </div>
                <div className="flex items-center gap-1">
                  <img
                    src="/icon-bookmark-grey.png"
                    alt="Bookmark"
                    className="h-4 w-4"
                  />
                </div>
              </div>
            </button>
          );
        })}
      </div>

      {/* Floating Button */}
      <button className="fixed bottom-6 right-6 bg-blue-500 text-white w-14 h-14 rounded-full shadow-lg hover:bg-blue-600 transition flex items-center justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 4v16m8-8H4"
          />
        </svg>
      </button>
    </div>
  );
}
